import { prodTypeService } from "@/api/services/prodTypeService";
import { enterpriseManageService } from "@/api/services/enterpriseManageService";
import { fileService } from "@/api/services/fileService";
import { COMMODITY_PRICE_TYPE } from "@zhihaoscm/meta";

/**获取品类枚举 */
export const getProdTypeEnum = async (state?: number) => {
    const data = await prodTypeService.selector(state).catch(() => {
        return [];
    });
    return data?.map(item => {
        const label = `${item.name}|${item.area}`;
        return {
            label: label,
            value: item.id
        };
    });
};

export const getDefaultParameterInfo = () => {
    return [
        { displayOrder: 0, parameterName: "含泥量", parameterValue: "" },
        { displayOrder: 1, parameterName: "压碎值", parameterValue: "" },
        { displayOrder: 2, parameterName: "石粉MB值", parameterValue: "" },
        { displayOrder: 3, parameterName: "含水率", parameterValue: "" },
        { displayOrder: 4, parameterName: "细粉含量", parameterValue: "" }
    ];
};
// 今天之后的日期
export const onDisabledDate = (date: Date) => {
    // 获取今天的日期，时间部分设置为00:00:00
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    // 返回true表示禁用该日期
    return date.getTime() < today.getTime();
};
// 商品详情 tab
export enum PROD_TAB {
    /**
     * 商品概览
     */
    OVERVIEW,
    /**
     * 排期明细
     */
    SCHEDULE,
    /**
     * 提货明细
     */
    DELIVERY,
    /**
     * 订单
     */
    ORDER,
    /**
     * 费用
     */
    FEE,
    /**
     * 发票
     */
    INVOICE,
    /**
     * 操作日志
     */
    OPERATION_LOG,
    /**
     * 拼团明细
     */
    GROUP_PURCHASE,
    /**
     * 助力明细
     */
    HELP_DETAIL
}
// 同后端定义的一样
export enum PROP_TYPE {
    /**
     * 寄售
     */
    CONSIGN = 1,
    /**
     * 拼团
     */
    GROUP_BY = 2,
    /**
     * 捡漏
     */
    BARGAIN = 3
}

export const getProdTabsByType = (prodType: number) => {
    if (prodType === PROP_TYPE.BARGAIN) {
        return [
            { label: "商品概览", value: PROD_TAB.OVERVIEW },
            { label: "助力明细", value: PROD_TAB.HELP_DETAIL },
            { label: "排期明细", value: PROD_TAB.SCHEDULE },
            { label: "费用明细", value: PROD_TAB.FEE },
            { label: "发票明细", value: PROD_TAB.INVOICE },
            { label: "操作日志", value: PROD_TAB.OPERATION_LOG }
        ];
    } else if (prodType === PROP_TYPE.GROUP_BY) {
        return [
            { label: "商品概览", value: PROD_TAB.OVERVIEW },
            { label: "拼团明细", value: PROD_TAB.GROUP_PURCHASE },
            { label: "排期明细", value: PROD_TAB.SCHEDULE },
            { label: "提货明细", value: PROD_TAB.DELIVERY },
            { label: "费用明细", value: PROD_TAB.FEE },
            { label: "发票明细", value: PROD_TAB.INVOICE },
            { label: "操作日志", value: PROD_TAB.OPERATION_LOG }
        ];
    } else {
        return [
            { label: "商品概览", value: PROD_TAB.OVERVIEW },
            { label: "排期明细", value: PROD_TAB.SCHEDULE },
            { label: "提货明细", value: PROD_TAB.DELIVERY },
            { label: "订单明细", value: PROD_TAB.ORDER },
            { label: "费用明细", value: PROD_TAB.FEE },
            { label: "发票明细", value: PROD_TAB.INVOICE },
            { label: "操作日志", value: PROD_TAB.OPERATION_LOG }
        ];
    }
};
//预览文件
export const onPreview = async (fileId: number) => {
    if (!fileId) return;
    const file = await fileService.getFileById(fileId);
    window.open(file.path, "_blank");
};
// 下拉多选
/** React 页面共享的商品类型远程查询状态；通过显式读取 value 保留旧导出形状。 */
export const productTypesConfig = {
    value: {
        loading: false,
        totalPage: 1,
        queryValue: undefined,
        options: [] as { label: string; value: string }[],
        productType: PROP_TYPE.CONSIGN,
        remoteMethod: async () => {
            productTypesConfig.value.loading = true;
            const res = await prodTypeService.selectorInProduct({
                keyword: productTypesConfig.value.queryValue,
                productType: productTypesConfig.value.productType
            });
            productTypesConfig.value.options = res.map(list => {
                return {
                    label: list.areaAbbreviation ? list.name + " | " + list.areaAbbreviation : list.name,
                    value: list.id
                };
            });
            productTypesConfig.value.loading = false;
        },
        init: (productType: number) => {
            productTypesConfig.value.queryValue = undefined;
            productTypesConfig.value.options = [];
            productTypesConfig.value.totalPage = 1;
            productTypesConfig.value.productType = productType;
        }
    }
};
// 供应商
/** React 页面共享的供应商远程查询状态；通过显式读取 value 保留旧导出形状。 */
export const supplierConfig = {
    value: {
        loading: false,
        totalPage: 1,
        queryValue: undefined,
        options: [] as { label: string; value: number }[],
        productType: PROP_TYPE.CONSIGN,
        remoteMethod: async () => {
            supplierConfig.value.loading = true;
            const res = await enterpriseManageService.selectorByProduct({
                name: supplierConfig.value.queryValue,
                productType: supplierConfig.value.productType
            });
            supplierConfig.value.options = res.map(list => {
                return {
                    label: list.supplierName,
                    value: list.id
                };
            });
            supplierConfig.value.loading = false;
        },
        init: (productType: number) => {
            supplierConfig.value.queryValue = undefined;
            supplierConfig.value.options = [];
            supplierConfig.value.totalPage = 1;
            supplierConfig.value.productType = productType;
        }
    }
};

export const gap = [20, 20] as [number, number];

// 价格类型提示信息
export const tips: {
    [key: number | string]: string;
} = {
    [COMMODITY_PRICE_TYPE.FIXED.code]: "固定价格：为实际交易价格，不受市场行情影响",
    [COMMODITY_PRICE_TYPE.ESTIMATED.code]: "预估价格：价格可能存在变动，以提货当日价格为准"
};
